import React from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import clsx from "clsx";
import { Row, Col } from "antd";
import { SalesLines } from "./inc/Components";
import moment from 'moment';
import { currencyFormat, displayPan } from "../../../../../helpers/utilities";
import FileUpload from "../../FileUpload";


export const BillSupply = React.forwardRef((props, ref) => {
    const { businessDetails, details, preview, proformaPreview, copy } = props;
    const classes = customStyles();

    const address = (details) => {
        let address = details?.address || details?.address1 || '';
        address += address !== '' ? ', ' : '';
        address += details?.area && details?.area?.name ? details?.area?.name : '';
        return address;
    }

    const address1 = (details) => {
        let address = details?.city && details?.city?.name ? details?.city?.name + ' - ' : '---';
        address += details?.pincode && details?.pincode?.code ? details?.pincode?.code : '---';
        address += details?.state && details?.state?.name ? ', ' + details?.state?.name : '---';
        address += details?.country && details?.country?.name ? ', ' + details?.country?.name : '---';
        return address;
    }

    const discountAmount = (items) => {
        const safeItems = items ?? [];
if (!safeItems.length) return 0;
        let totalDiscount = Number(details?.cashDiscountAmount || 0);
        for (const v of items) {
            const qty = Number(v.quantity || 0);
            const price = Number(v.pricePerUnit || 0);
            const discountAmt = Number(v.discountAmount || 0);
            const discountPercent = Number(v.discountPercent || 0);

            // Line-level fixed discount
            totalDiscount += discountAmt;

            // Percentage discount
            const percentDiscount = ((qty * price) * discountPercent) / 100;

            if (v.amount < 0) {
                totalDiscount -= percentDiscount;
            } else {
                totalDiscount += percentDiscount;
            }
        }

        return Number(totalDiscount.toFixed(2));
    }

    return (
        <>
            <div className={clsx(classes.formatSix)}>
                <div className={clsx(classes.positionRelative, classes.topBar, classes.margin55t)} style={{ marginTop: businessDetails?.logoUri ? 33 : 0 }}>
                    <h1>{proformaPreview ? 'PROFORMA' : 'Bill of Supply'}</h1>
                    {
                        (businessDetails?.logoUri || details?.business?.logoUri) &&
                        <div className={classes.downloadimages}>
                            <div className={clsx(classes.productImageUpload, classes.dropDown)}>
                                <FileUpload filePath={details?.business?.logoUri || businessDetails?.logoUri || ''} view={true} />
                            </div>
                        </div>
                    }
                </div>
                <div className={classes.downloadsecondbar} style={{ paddingTop: businessDetails?.logoUri ? 15 : 0 }}>
                    <Row align="top">
                        <Col span={4} className={clsx(classes.bill, classes.paddingBottom10)}>
                            <div style={{ display: "flex" }}>
                                <div>
                                    <h6>{preview || proformaPreview || details?.invoiceAmount >= 0 ? 'Invoice Number' : 'Credit Note'}</h6>
                                    <h1>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.salesInvoice?.serialNo || details?.serialNo || '---'}</h1>
                                </div>
                                {
                                    (details?.salesQuote?.serialNo || details?.salesQuote?.reference) && <div style={{ marginLeft: 20 }}>
                                        <h6> Reference</h6>
                                        <h1>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.salesQuote?.reference || details?.salesQuote?.serialNo || '---'}</h1>
                                    </div>
                                }
                            </div>
                        </Col>
                        <Col span={16} className={clsx(classes.bill, classes.textAlignCenter)}>
                            {!proformaPreview && <p>Composition Taxable Person not eligible to collect tax on supplies</p>}</Col>
                        <Col span={4} className={clsx(classes.textAlignRight, classes.marginBottom10)}>
                            {proformaPreview ? '' : `${copy ? 'Duplicate Copy' : 'Original'}`}
                        </Col>
                    </Row>
                    <Row className={clsx(classes.bill, classes.alginitemNormal, classes.paddingBottom10)}>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <h6 >Bill From</h6>
                            <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : businessDetails?.businessName || details?.business?.name || '---'}</p>
                            <p>{preview ? <span className={clsx(classes.greyBg, classes.largeWidth)}></span> : address(businessDetails || details?.business)}</p>
                            <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : address1(businessDetails || details?.business)}</p>
                            <Row className={clsx(classes.bill, classes.margin15t)}>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                    <Row>
                                        <Col span={24}>
                                            <Row>
                                                <Col span={3}>
                                                    <h6>Email</h6>
                                                </Col>
                                                <Col span={21}>
                                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.email || details?.business?.email || '---'}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={12}>
                                            <Row>
                                                <Col span={6}>
                                                    <h6>Ph No.</h6>
                                                </Col>
                                                <Col span={18}>
                                                    <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.mobile || details?.business?.mobile || '---'}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                        {
                                            (details.includeGst || preview) && <Col span={12}>
                                                <Row>
                                                    <Col span={6}>
                                                        <h6>GSTIN</h6>
                                                    </Col>
                                                    <Col span={18}>
                                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : businessDetails?.gst || details?.business?.gstNumber || '---'}</p>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        }
                                        {
                                            (businessDetails?.pan || details?.business?.panNumber) && <Col span={24}>
                                                <Row>
                                                    <Col span={3}>
                                                        <h6>{displayPan(businessDetails?.pan || details?.business?.panNumber || '')[0]}</h6>
                                                    </Col>
                                                    <Col span={21}>
                                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : displayPan(businessDetails?.pan || details?.business?.panNumber || '')[1]}</p>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        }
                                    </Row>
                                </Col>

                            </Row>
                        </Col>
                    </Row>
                </div>
                <Row className={clsx(classes.CalypsoborderTop)}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={clsx(classes.CalypsoborderRight, classes.CalypsoborderLeft, classes.bill, classes.billtoppadding)} >
                        <h6>Bill To</h6>
                        <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.name || details?.customerName || details?.customer_name || '---'}</p>
                        <p>{preview ? <span className={clsx(classes.greyBg, classes.largeWidth)}></span> : address(details)}</p>
                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : address1(details)}</p>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={clsx(classes.CalypsoborderRight, classes.bill, classes.billtoppadding)}>
                        <h6>Shipped To</h6>
                        <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.name || details?.customerName || details?.customer_name || '---'}</p>
                        <p>{preview ? <span className={clsx(classes.greyBg, classes.largeWidth)}></span> : address(details)}</p>
                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : address1(details)}</p>
                    </Col>
                </Row>
                <Row className={clsx(classes.CalypsoborderBottom)}>
                    <Col span={12} className={clsx(classes.CalypsoborderRight, classes.CalypsoborderLeft, classes.bill, classes.billbottompadding)}>
                        <Row>
                            <Col span={24}>
                                <Row>
                                    <Col span={3}>
                                        <h6>Email</h6>
                                    </Col>
                                    <Col span={21}>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.email || details?.customer_email || '---'}</p>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={12}>
                                <Row>
                                    <Col span={6}>
                                        <h6>Ph No.</h6>
                                    </Col>
                                    <Col span={18}>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.phone || details?.customer_phone || '---'}</p>
                                    </Col>
                                </Row>
                            </Col>
                            {
                                (details.includeGst || preview) &&
                                <Col span={12}>
                                    <Row>
                                        <Col span={6}>
                                            <h6>GSTIN</h6>
                                        </Col>
                                        <Col span={18}>
                                            <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.customer?.gstin || '---'}</p>
                                        </Col>
                                    </Row>
                                </Col>
                            }
                            {
                                details?.customer?.pan && <Col span={24}>
                                    <Row>
                                        <Col span={3}>
                                            <h6>{displayPan(details?.customer?.pan)[0]}</h6>
                                        </Col>
                                        <Col span={21}>
                                            <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : displayPan(details?.customer?.pan)[1]}</p>
                                        </Col>
                                    </Row>
                                </Col>
                            }
                        </Row>
                    </Col>
                    <Col span={12} className={clsx(classes.CalypsoborderRight, classes.bill, classes.billbottompadding)}>
                        <Row>
                            <Col span={24}>
                                <Row>
                                    <Col span={3}>
                                        <h6>Email</h6>
                                    </Col>
                                    <Col span={21}>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.email || details?.customer_email || '---'}</p>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={12}>
                                <Row>
                                    <Col span={6}>
                                        <h6>Ph No.</h6>
                                    </Col>
                                    <Col span={18}>
                                        <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.phone || details?.customer_phone || '---'}</p>
                                    </Col>
                                </Row>
                            </Col>
                            {
                                (details.includeGst || preview) &&
                                <Col span={12}>
                                    <Row>
                                        <Col span={6}>
                                            <h6>GSTIN</h6>
                                        </Col>
                                        <Col span={18}>
                                            <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.customer?.gstin || '---'}</p>
                                        </Col>
                                    </Row>
                                </Col>
                            }
                            {
                                details?.customer?.pan && <Col span={24}>
                                    <Row>
                                        <Col span={3}>
                                            <h6>{displayPan(details?.customer?.pan)[0]}</h6>
                                        </Col>
                                        <Col span={21}>
                                            <p>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : displayPan(details?.customer?.pan)[1]}</p>
                                        </Col>
                                    </Row>
                                </Col>
                            }
                        </Row>
                    </Col>
                </Row>
                <div className={clsx(classes.bill)}>
                    <div className={clsx(classes.downloadsRectangle)}>
                        <Row>
                            <Col span={3}><h6>Invoice Date</h6></Col>
                            <Col span={3}><h6>Due Date</h6></Col>
                            <Col span={4}><h6>Pmt. Method</h6></Col>
                            <Col span={2} ><h6>Currency</h6></Col>
                            <Col span={(details.includeGst || preview) ? 3 : 5} className={clsx(classes.textAlignRight)}><h6>Invoice Amount</h6></Col>
                            {
                                (details.includeGst || preview) &&
                                <Col span={3} className={clsx(classes.textAlignRight)}><h6>GST Amount</h6></Col>
                            }
                            {
                                discountAmount(details?.selfBillItems) > 0 && <Col span={3} className={clsx(classes.textAlignRight)}><h6>Discount</h6></Col>
                            }
                            <Col span={(details.includeGst || preview) ? 3 : 4} className={clsx(classes.textAlignRight)}><h6>Net Amount</h6></Col>
                        </Row>
                        <Row>
                            <Col span={3}> <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.invoiceDate ? moment(details.invoiceDate).format('DD MMM YYYY') : '---'}</p></Col>
                            <Col span={3}> <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.dueDate ? moment(details.dueDate).format('DD MMM YYYY') : '---'}</p></Col>
                            <Col span={4}> <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.mop?.method || '---'}</p></Col>
                            <Col span={2}> <p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : details?.currency?.name || '---'}</p></Col>
                            <Col span={(details.includeGst || preview) ? 3 : 5} className={clsx(classes.textAlignRight)}><p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${currencyFormat(details?.invoiceAmount ? details?.invoiceAmount : 0)}`}</p></Col>
                            {
                                (details.includeGst || preview) && <Col span={3} className={clsx(classes.textAlignRight)}><p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${currencyFormat(details?.selfBillItems ? details?.selfBillItems.reduce((a, v) => a = parseFloat(a) + parseFloat(v.gstAmount), 0) : 0)}`}</p></Col>
                            }
                            {
                                discountAmount(details?.selfBillItems) > 0 &&
                                <Col span={3} className={clsx(classes.textAlignRight)}><p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${currencyFormat(discountAmount(details?.selfBillItems))}`}</p></Col>
                            }
                            <Col span={(details.includeGst || preview) ? 3 : 4} className={clsx(classes.textAlignRight)}><p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${currencyFormat(details?.assessableValue || (details?.selfBillItems ? details?.invoiceAmount - (details?.roundOffAmount || 0) - details?.selfBillItems.reduce((a, v) => a = parseFloat(a) + parseFloat(v.gstAmount), 0) : 0))}`}</p></Col>
                        </Row>
                    </div>
                </div>
                <div className={clsx(classes.PlaceofSupply, classes.customForm5)}>
                    <Row>
                        <Col span={(details?.reference || details?.salesQuote?.serialNo) ? 8 : 16} className={clsx(classes.bill)}>
                            <div style={{ display: "flex" }}>
                                <h6 style={{ fontSize: "14px", margin: 0 }}>Place of Supply</h6>
                                <p style={{ paddingLeft: "10px", fontSize: "14px", margin: 0 }}>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.state?.name || '---'}</p>
                            </div>
                        </Col>
                        {
                            (details?.reference || details?.salesQuote?.serialNo) && <Col span={8} className={clsx(classes.CalypsoborderLeft, classes.bill)}>
                                <div style={{ display: "flex" }}>
                                    <h6 style={{ paddingLeft: "10px", fontSize: "14px", margin: 0 }}>Reference </h6>
                                    <p style={{ paddingLeft: "10px", fontSize: "14px", margin: 0 }}>{preview ? <span className={clsx(classes.greyBg, classes.mediumWidth)}></span> : details?.reference || details?.salesQuote?.serialNo || '---'}</p>
                                </div>
                            </Col>
                        }
                        {
                            (details?.fromDate || details?.toDate) &&
                            <Col span={8} className={clsx(classes.CalypsoborderLeft, classes.bill)}>
                                <div style={{ display: "flex" }}>
                                    <h6 style={{ paddingLeft: "10px", fontSize: "14px", margin: 0 }}>Service Date</h6>
                                    <p style={{ paddingLeft: "10px", margin: 0, fontSize: "14px" }}>{details.fromDate && moment(details.fromDate).format('DD MMM YYYY')}{details.toDate && (details.toDate !== details.fromDate) && ` to ${moment(details.toDate).format('DD MMM YYYY')}`} </p>
                                </div>
                            </Col>
                        }
                    </Row>
                </div>
                <div className={clsx(classes.thirdSection)}>
                    <SalesLines ref={ref} {...props} terms={true} />
                </div>
            </div>
        </>
    )
})